
import {SuperDebug} from '../utils/debug/Sdebug';
let debug_auth = SuperDebug('router-authentication', true);

import {Session} from "../h5_src/framework/Session";

export class Authentication {

    public static checkAccess(to) {

        let ret = {
            isLoggedIn: Session.isLoggedIn(),
            userId: Session.getUserId(),
            needLogin: false,
            param: undefined
        };

        let publicPages = {
            '/pages/login': 1,
            '/pages/logout': 1,
            '/pages/error-404': 1,
            '/pages/recoverPassword': 1,
        };

        if (!publicPages[to.fullPath] && !ret.isLoggedIn) {

            let loginMap = {
                '/':                1,
                '/home/index':      1
            };

            // console.log(['user-error-to', to.fullPath]);

            let redirectPath    = '/pages/login';

            ret.needLogin = true;
            ret.param = {
                replace: true,
                path: redirectPath,
                query: {redirect: to.fullPath}
            };

        }

        return ret;

    }
}
